if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.fetchCustomProductData();

        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.input.min = min;

        if (max) {
          this.input.max = max;
        } else {
          this.input.removeAttribute("max");
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(".quantity__rules-cart .loading__spinner").classList.remove("hidden--important");
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, "text/html");
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(".quantity__rules-cart .loading__spinner").classList.add("hidden--important");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = [".quantity__input", ".quantity__rules", ".quantity__label"];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = ["data-cart-quantity", "data-min", "data-max", "step"];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      fetchCustomProductData() {
        const productUrl = this.dataset.url;
        if (!productUrl) return;

        const handle = productUrl.split("/").pop();
        fetch(`/products/${handle}?view=custom`)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed load custom product data");
            }
            return response.json();
          })
          .then((data) => {
            this.trackProductView(data);
            return data;
          })
          .catch((error) => {
            console.error("Error fetching custom product data:", error);
          });
      }

      /**
       * Constructs the analytics payload for product view tracking
       * @param {Object} data - The custom product data from the API
       * @returns {Object} The analytics payload
       */
      constructAnalyticsPayload(data) {
        const { metafields, product } = data;

        if (!metafields) {
          return null;
        }

        const { material, color, db_condition, discounted_tier, discounted_rate, style, categories } = metafields;
        const PRICE_DIVISOR = 100;
        const compareAtPrice = parseFloat(product.compare_at_price) / PRICE_DIVISOR;
        const currentPrice = parseFloat(product.price) / PRICE_DIVISOR;
        const categoryNames = categories ? categories.map((category) => category.name) : [];

        return {
          brand: product.vendor || "",
          categories: categoryNames,
          category: product.type || "",
          color,
          compare_at_price: compareAtPrice,
          condition: db_condition,
          currency: "USD",
          days_on_sale: 0,
          discount_tier: discounted_tier,
          is_sold_out: product.available ? 0 : 1,
          material,
          name: product.title || "",
          price: currentPrice,
          product_discount_amount: compareAtPrice - currentPrice,
          product_discount_rate: discounted_rate,
          product_id: product.id,
          quantity: 1,
          sku: product.variants?.[0]?.sku || "",
          style,
          url: window.location.href,
          value: compareAtPrice,
        };
      }

      trackProductView(data) {
        try {
          const payload = this.constructAnalyticsPayload(data);
          segmentTrack({ eventName: "Product Viewed", payload });
        } catch (error) {
          console.error("Error tracking product view:", error);
        }
      }
    },
  );
}

document.addEventListener("pointerdown", function (event) {
  const button = event.target.closest("button.swym-add-to-wishlist-view-product");
  if (!button) return;
  if (!isLoggedIn || isLoggedIn === "false") {
    event.preventDefault();
    event.stopImmediatePropagation();
    const loginUrl = getLoginUrl();
    window.location.replace(loginUrl);
  }
});

sessionStorage.setItem("cameFrom", document.referrer);

window.addEventListener("popstate", function () {
  const cameFrom = sessionStorage.getItem("cameFrom");
  if (cameFrom && !cameFrom.includes(window.location.pathname)) {
    window.location.href = cameFrom;
  } else {
    window.history.go(-2);
  }
});
